import { ErrorOutlineRounded } from '@mui/icons-material';
import { Button } from '@mui/material';

import Text from '@components/Text';
import { t } from '@i18n';

import './styles.scss';

const WALLET_HELP_URL = 'https://help.ginastee.com/pt-br/financeiro-wallet-e-saques/como-configurar-sua-wallet-no-ginastee';

export default function PaymentsUnavailableBanner() {
  return (
    <div className='payments-unavailable-banner' role='status'>
      <ErrorOutlineRounded className='payments-unavailable-banner__icon' />
      <Text.span className='payments-unavailable-banner__text' contrast={9}>
        {t('checkout.paymentsUnavailable.message')}
      </Text.span>
      <Button
        className='payments-unavailable-banner__button'
        href={WALLET_HELP_URL}
        target='_blank'
        rel='noopener noreferrer'
      >
        {t('checkout.paymentsUnavailable.action')}
      </Button>
    </div>
  );
}
